// extracted by css-extract-rspack-plugin
export default {"wrapper":"BidInput-module__wrapper--hjblO","rare":"BidInput-module__rare--mdN6k","average":"BidInput-module__average--BUbg2","often":"BidInput-module__often--HdaAm"};